module.exports = __webpack_public_path__ + "img/head-right.e38f5dd4.jpg";